import React from 'react';

export interface EmptyPredictionsSubtextProps
  extends React.HTMLProps<HTMLDivElement> {
  text: string;
}

const EmptyPredictionsSubtext: React.FC<EmptyPredictionsSubtextProps> = ({
  text,
  ...props
}) => (
  <div
    className={`text-[1.2rem] font-normal leading-[1.8rem] text-center text-[#000c42] max-w-[25rem] mt-[0.8rem] ${props.className || ''}`}
    {...props}
  >
    {text}
  </div>
);

export default EmptyPredictionsSubtext;
